import { Outlet } from "react-router";

export default function Dashboard() {
  return (
    <Outlet />
  );
}
